<template>
  <div>
    <el-row>
        <el-col :span="6">
          <el-form :model="form" :rules="form.rules" ref="form">
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" clearable type="email"></el-input>
            </el-form-item>
            <el-form-item label="Пароль" prop="password">
              <el-input v-model="form.password" type="password" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="signUp('form')">Создать</el-button>
            </el-form-item>
          </el-form>
        </el-col>
    </el-row>
    <p>Вернуться к <router-link to="/login">входу в аккаунт</router-link></p>
    <p><b>Внимание: при создания аккаунта не требуется указывать доступы от Ваших аккаунтов игровых проектов Minecraft. На текущий момент отсутствует подтверждение почты, таким образом данные по Вашей почте и паролю могут быть произвольными, кроме уже имеющихся в базе почтовых адресов и с минимальной длиной пароля в 6 символов.</b></p>
    <p><b>При помощи системы Экспорта/Импорта предметов Вы сможете легко перенести настройки с одного аккаунта на другой.</b></p>
  </div>  
</template>

<script>
// import firebase from 'firebase';
import firebase from 'firebase/app';
require('firebase/auth');
import {db} from '../firebase.js';
export default {
  data() {
    return {
      form:{
        email: '',
        password: '',
        name: '',
        rules: {
          email: [
            {type: 'email', message: 'Проверьте адрес электронной почты', trigger: 'blur',},
            {required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
          ],
          password: [
            {required: true, message: 'Это поле обязательно для заполнения', trigger: 'blur',},
            {min: 6, message: 'Минимальная длина пароля должна быть 6 символов', trigger: 'blur'},
          ],
        },
      },
    }
  },
  methods: {
    signUp: function(formName) {
      var self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          /*firebase.auth().createUserWithEmailAndPassword(self.form.email, self.form.password).then(
            (user) => {
            },
            (err) => {
              alert('Ошибка: ' + err.message)
            }
          );*/
          var credential = firebase.auth.EmailAuthProvider.credential(self.form.email, self.form.password);
          firebase.auth().currentUser.linkWithCredential(credential).then(function(usercred) {
            var user = usercred.user;
            // console.log("Anonymous account successfully upgraded", user);
            self.$notify({title: 'Успех', message: 'Приветствую, Вы успешно создали аккаунт', type: 'success'});
            self.$router.push({name: 'profile'});
          }, function(error) {
            console.log("Error upgrading anonymous account", error);
          });
        } else {
          self.$notify({title: 'Ошибка', message: 'Ошибка валидации формы', type: 'error'});
          return false;
        };
      });
    },
  },
};
</script>